export interface IAuthForbiddenResult<TErrorCode> {
  errorCode: TErrorCode;
  message: string;
}

export enum AuthenticationErrorCode {
  passwordPolicy = 'password-policy',
  ssoOnlyAccess = 'sso-only-access',
  accountIsBeingDeleted = 'account-is-being-deleted',
  accountDeactivated = 'account-deactivated',
  tooManyLoginAttempts = 'too-many-login-attempts',
  accountBlocked = 'account-blocked'
}
